import { render } from "./DeliveriesList.vue?vue&type=template&id=1ce9cb1f&scoped=true"
import script from "./DeliveriesList.vue?vue&type=script&lang=js"
export * from "./DeliveriesList.vue?vue&type=script&lang=js"

import "./DeliveriesList.vue?vue&type=style&index=0&id=1ce9cb1f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Isaias\\Documents\\Vue\\EntregasApp\\Lupnova\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce9cb1f"]])

export default __exports__